<urban-splash-screen id="splash-screen" [animationType]="'fade-out'" [animationDuration]="0.5"></urban-splash-screen>

<router-outlet></router-outlet>

@if (loaderService.isLoading()) {
<urban-loader />
}

<urban-offline-banner />
@if (offlineBlocking()) {
<urban-offline-page />
}